import type { RuleArea } from "@unbox/api";
import { RuleBuilderDrawer as BlocklistRuleBuilderDrawer } from "@/components/blocklist/rules/rule-builder-drawer";
import { RuleBuilderDrawer as CohortRuleBuilderDrawer } from "@/components/creator-cohorts/cohort-rules-drawer/components/rule-builder-drawer";
import { RuleBuilderDrawer as SampleRuleBuilderDrawer } from "@/components/sample-requests/sample-rules-drawer/components/rule-builder-drawer";

type RuleBuilderProps = {
  area: RuleArea;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ruleId?: string;
  onCreated?: () => void;
};

export const RuleBuilder = ({ area, open, onOpenChange, ruleId, onCreated }: RuleBuilderProps) => {
  if (area === "cohort") {
    return (
      <CohortRuleBuilderDrawer
        open={open}
        onOpenChange={onOpenChange}
        ruleId={ruleId}
        onCohortsChanged={() => {}}
        onCreated={onCreated}
      />
    );
  }

  if (area === "sample") {
    return <SampleRuleBuilderDrawer open={open} onOpenChange={onOpenChange} ruleId={ruleId} onCreated={onCreated} />;
  }

  return <BlocklistRuleBuilderDrawer open={open} onOpenChange={onOpenChange} ruleId={ruleId} onCreated={onCreated} />;
};
